/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FinnairItineraryItemFlightStatus {
  CONFIRMED = 'CONFIRMED',
  WAITLISTED = 'WAITLISTED',
  CANCELED = 'CANCELED',
  FLOWN = 'FLOWN',
  CHECKED_IN = 'CHECKED_IN'
}

